import { render, staticRenderFns } from "./SourceRatingImportDialog.vue?vue&type=template&id=763ed113"
import script from "./SourceRatingImportDialog.vue?vue&type=script&lang=js"
export * from "./SourceRatingImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports